module.exports = __webpack_public_path__ + "img/novelfive.259666b9.png";